import EditBiometrics from "../components/edit/EditBiometrics";



const BiometricsEdit = () => {
  return (
    <section>
        <h2 className="title">Update Biometric</h2>
        <EditBiometrics />
    </section>
  )
}

export default BiometricsEdit